export const layoutTokens = {
  sidebarWidth: 72,
  appbarHeight: 48,
  footerHeightDesktop: 30,
  footerHeightMobile: 22,
  panelHeaderHeight: 36,
  panelFooterHeight: 32,
  panelIconButtonSize: 26,
};

export const colorTokens = {
  backgroundPrimary: "#FFFFFF",
  sidebarBackground: "#334155",
  appbarBackground: "#F8FAFC",
  footerBackground: "#F8FAFC",
  panelHeaderBackground: "#F8FAFC",
  border: "#E5E7EB",
  textPrimary: "#1E293B",
  textSecondary: "#64748B",
  sidebarText: "#CBD5E1",
  sidebarActiveText: "#FFFFFF",
  accent: "#3B82F6",
};
